import React from 'react';
import Link from '../Link/Link';

import styles from './Accordion.module.scss';
import ImagesFooter from './footerLogos';
import SocialMediaLogos from './socialMedia';

const Accordion = () => {
  return (
    <div className={styles.root}>
      <input className={styles.toggle} type='checkbox' />
      <i className={styles.label}>&nbsp;</i>
      <div className={styles.collapsed}>
        <div className='container-lg d-block'>
          <div className='mt-4 col-12'>
            <Link to='/'>
              <img
                className={styles.logo}
                src={`${process.env.PUBLIC_URL}/images/footer/swissmedicalblanco.svg`}
                alt='Swiss Medical Group'
                loading='lazy'
              />
            </Link>
            <p className={`${styles.footerSMG} ${styles.textSize} mb-0`}>
              <strong>© SWISS MEDICAL 2024</strong>
            </p>
            <p className={`${styles.textSize} mb-0`}>Todos los derechos reservados</p>
            <p className={`${styles.textSize} mb-0`}>
              <a
                href={`${process.env.PUBLIC_URL}/pdf/privacy-policy/politica_privacidad.pdf`}
                target='_blank'
                className={styles.linkFooter}
              >
                Politica de Privacidad del Sitio
              </a>
            </p>
            <p className={`${styles.textSize} mb-0`}>
              <a
                href={`${process.env.PUBLIC_URL}/pdf/terms-and-conditions/terminos.pdf`}
                target='_blank'
                className={styles.linkFooter}
              >
                Términos y Condiciones
              </a>
            </p>
          </div>
          <ImagesFooter className='d-none d-md-block' />
          <SocialMediaLogos />
        </div>
      </div>
    </div>
  );
};

export default Accordion;
